import pkceChallenge from 'pkce-challenge';

export const generateAuthDetails = async (
  authURL: string,
  clientId: string,
  redirectUri: string,
  pathname: string,
) => {
  // Generate PKCE
  // Check if all values already exists if true use them

  if (pathname === '/authenticate') {
    const codeVerifier = sessionStorage.getItem('codeVerifier');
    const codeChallenge = sessionStorage.getItem('codeChallenge');
    const state = sessionStorage.getItem('state');
    const nonce = sessionStorage.getItem('nonce');
    if (codeVerifier && codeChallenge) {
      return {
        loginUrl: `${authURL}auth?${new URLSearchParams({
          client_id: clientId,
          redirect_uri: redirectUri,
          response_type: 'code',
          scope: 'openid',
          state: state ?? '', // Use the nullish coalescing operator to default to an empty string if state is null
          nonce: nonce ?? '', // Use the nullish coalescing operator to default to an empty string if nonce is null
          code_challenge: codeChallenge,
          code_challenge_method: 'S256',
        })}`,
      };
    }
  }

  const pkce = await pkceChallenge();
  const codeVerifier = pkce.code_verifier;
  const codeChallenge = pkce.code_challenge;

  // Store PKCE values in sessionStorage
  sessionStorage.setItem('codeVerifier', codeVerifier);
  sessionStorage.setItem('codeChallenge', codeChallenge);

  console.log('codeVerifier: ', codeVerifier);
  console.log('codeChallenge: ', codeChallenge);

  // Generate State Parameter
  const state = crypto.randomUUID();
  sessionStorage.setItem('state', state);

  // Generate Nonce Parameter
  const nonce = crypto.randomUUID();
  sessionStorage.setItem('nonce', nonce);

  // Construct Login URL
  const loginUrl = `${authURL}auth?${new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'openid',
    state,
    nonce,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
  })}`;

  return { loginUrl };
};
